import React from 'react'
import { terminalBarTheme, pillButtonTheme } from "../../../common/styles/theme"
import Button from "@material-ui/core/Button"
import { ThemeProvider, styled } from "@material-ui/styles"
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';



const TerminalButton = ({i, handleClick, isPillButton, btn}) => {
    let background = {
        start: '#f46b45',
        end: '#eea849',
        fontColor: "rgba(0, 0, 0, 0.70)"
    }

    if (isPillButton) {
        if (btn.style === 'red') {
            background.start = '#ED213A'
            background.end = '#93291E'
        }
        else if (btn.style === "blue") {
            background.start = '#1e3c72'
            background.end = '#2a5298'
        }
        background.fontColor = "white"
    }

    const MyButton = styled(Button)({
        background: background.end,
        transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
        '&:hover': {
            transform: 'scale(1.05)',
            background: background.end,
        },
        border: 0,
        borderRadius: 3,
        height: 48,
        padding: '0 30px',
        color: background.fontColor
    });

    const theme = isPillButton ? pillButtonTheme : terminalBarTheme

    return (
        <ThemeProvider theme={theme}>
            <MyButton
                key={i}
                onClick={() => {handleClick(i)}}
                variant="contained"
                disableElevation
                startIcon={<BorderColorTwoToneIcon />}
                fullWidth
            >
                {btn.text}
            </MyButton>
        </ThemeProvider>
    )

}

export default TerminalButton
